/** @format */

import React, { useEffect, useState } from "react";
import { Button } from "@mantine/core";
import flat from "flat";
import { BeatLoader } from "react-spinners";
import { loadingStates, validateEmail } from "../../utilities/utilities";
import colors from "../../utilities/design";
import { showNotification } from "@mantine/notifications";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getPartiesList,
  getWorkSpaceLists,
} from "../../utilities/apis/parties";
import AgreementParty from "./AgreementParty";
import userPartyCreateHook from "../../hooks/usePartyCreate";
import LegacyAgreementParty from "./LegacyAgreementParty";
import { getOrgDetailsFromMaster } from "../../utilities/apis/users";

const LegacyAgreementForm3 = ({
  setLegacyAgreementFormValue,
  legacyAgreementFormValue,
  uiConfigs,
  setUiConfigs,
  saveAgreement,
}) => {
  console.log({ legacyAgreementFormValue });
  const [dropDownNames, setDropDownNames] = useState([]);
  const [parties, setParties] = useState([]);
  const [errors, setErrors] = useState({});
  const [orgDetails, setOrgDetails] = useState(null);
  // const[name, setName]= useState("");

  const partiesApi = async (name) => {
    const { data: res } = await apiWrapWithErrorWithData(
      getPartiesList({ name })
    );
    setParties(res);
    const names = res.map(({ name: val }) => val);
    setDropDownNames(names);
  };

  const fetchOrgDetails = async () => {
    try {
      const resp = await apiWrapWithErrorWithData(getOrgDetailsFromMaster());
      console.log("Organization API response:", resp); // Debug log
      if (resp.success && resp.result && resp.result.length > 0) {
        console.log("Organization details:", resp.result[0]); // Debug log
        const orgData = {
          address: resp.result[0].details["regAddress"] || "",
          entityType: resp.result[0].details["entityType"] || "",
          name: resp.result[0]["name"] || "",
          brandName: resp.result[0].details?.brandName || "",
        };
        setOrgDetails(orgData);
        
        // Auto-populate first party if it's not already filled
        if (!legacyAgreementFormValue.firstParty.name) {
          setLegacyAgreementFormValue({
            ...legacyAgreementFormValue,
            firstParty: {
              ...legacyAgreementFormValue.firstParty,
              name: orgData.name,
              entityType: orgData.entityType,
              address: orgData.address,
              type: "Entity",
            },
          });
        }
      }
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  };

  useEffect(() => {
    partiesApi();
    fetchOrgDetails();
  }, []);

  console.log(dropDownNames);

  const validate = () => {
    const keys = {};

    const firstParty = legacyAgreementFormValue.firstParty;
    const secondParty = legacyAgreementFormValue.secondParty;
    // if (firstParty.type === "Entity") {
    //   if (!firstParty.signatory) {
    //     keys.firstParty = { ...keys.firstParty, signatory: "Signing Authority is required" };
    //   }
    // }

    if (firstParty.type === "Entity" && secondParty.type === "Entity") {
      if (!firstParty.entityType || firstParty.entityType.length < 3) {
        keys.firstParty = { entityType: "Please fill Entity Type." };
      } else if (!secondParty.entityType || secondParty.entityType.length < 3) {
        keys.secondParty = { entityType: "Please fill Entity Type." };
      } else if (!firstParty.name || firstParty.name.length < 3) {
        keys.firstParty = { name: "Please enter 3 or more characters." };
      } else if (!secondParty.name || secondParty.name.length < 3) {
        keys.secondParty = { name: "Please enter 3 or more characters." };
      }
    } else if (
      firstParty.type === "Individual" &&
      secondParty.type === "Individual"
    ) {
      if (!firstParty.indi_name || firstParty.indi_name.length < 3) {
        keys.firstParty = { indi_name: "Please enter 3 or more characters." };
      } else if (!secondParty.indi_name || secondParty.indi_name.length < 3) {
        keys.secondParty = { indi_name: "Please enter 3 or more characters." };
      }
    } else if (
      firstParty.type === "Entity" &&
      secondParty.type === "Individual"
    ) {
      if (!firstParty.entityType || firstParty.entityType.length < 3) {
        keys.firstParty = { entityType: "Please fill Entity Type." };
      } else if (!firstParty.name || firstParty.name.length < 3) {
        keys.firstParty = { name: "Please enter 3 or more characters." };
      } else if (!secondParty.indi_name || secondParty.indi_name.length < 3) {
        keys.secondParty = { indi_name: "Please enter 3 or more characters." };
      }
    } else if (
      firstParty.type === "Individual" &&
      secondParty.type === "Entity"
    ) {
      if (!secondParty.entityType || secondParty.entityType.length < 3) {
        keys.secondParty = { entityType: "Please fill Entity Type." };
      } else if (!secondParty.name || secondParty.name.length < 3) {
        keys.secondParty = { name: "Please enter 3 or more characters." };
      } else if (!firstParty.indi_name || firstParty.indi_name.length < 3) {
        keys.firstParty = { indi_name: "Please enter 3 or more characters." };
      }
    }

    if (Object.keys(keys).length !== 0) {
      setErrors(keys);
      showNotification({
        color: "red",
        title: "Agreement Form",
        message: "Please check all fields are filled properly.",
      });
    }

    return Object.keys(keys).length === 0;
  };

  const savePrev = async () => {
    setUiConfigs({
      ...uiConfigs,
      currentStep: 0,
    });
  };

  const saveNext = async () => {
    if (validate()) {
      await saveAgreement();
      setUiConfigs({
        ...uiConfigs,
        currentStep: 2,
      });
    }
  };
  console.log("errors: ", errors);

 
  const handlePartySelect = (partyKey, selectedName) => {
  const selectedPartyData = parties.find((p) => p.name === selectedName);

  if (selectedPartyData) {
    setLegacyAgreementFormValue((prev) => ({
      ...prev,
      [partyKey]: {
        ...prev[partyKey],
        name: selectedName,
        // Map API fields to your form fields
        type: selectedPartyData.type || "Entity",
        entityType: selectedPartyData.companyType || "Company",
        
        // Brand and Emails
        brandName: selectedPartyData.brandName || "",
        email: selectedPartyData.email || "",
        pocemail: selectedPartyData.email || "",
        
        // Representatives and Signatories
        signatory: selectedPartyData.signatory || "",
        representative: selectedPartyData.representative || "",

        // Addresses: Check both fields in case one is null
        address: selectedPartyData.registeredOfficeAddress || selectedPartyData.residenceOf || "",
        corporateAddress: selectedPartyData.corporateOfficeAddress || "",
      },
    }));
  } else {
    // If it's a new "created" item, just update the name
    setLegacyAgreementFormValue((prev) => ({
      ...prev,
      [partyKey]: {
        ...prev[partyKey],
        name: selectedName,
      },
    }));
  }
};
  return (
    <div className="w-full flex flex-col my-4">
      <div className="flex flex-col justify-between my-2">
        <LegacyAgreementParty
          errors={errors["firstParty"] && errors["firstParty"]}
          legacyAgreementFormValue={legacyAgreementFormValue}
          dropDownNames={dropDownNames}
          setLegacyAgreementFormValue={setLegacyAgreementFormValue}
          partyName={"firstParty"}
          setDropDownNames={setDropDownNames}
          isReadOnly={true}
          // setName={setName}
        />

        <LegacyAgreementParty
          errors={errors["secondParty"] && errors["secondParty"]}
          legacyAgreementFormValue={legacyAgreementFormValue}
          dropDownNames={dropDownNames}
          setLegacyAgreementFormValue={setLegacyAgreementFormValue}
          onPartySelect={handlePartySelect} // New Prop
          partyName={"secondParty"}
          setDropDownNames={setDropDownNames}
          // setName={setName}
        />
        {/* {[1, 2, 3].includes(addParty) ? (
          <AgreementParty
            legacyAgreementFormValue={legacyAgreementFormValue}
            dropDownNames={dropDownNames}
            form={form}
            partyName={"thirdParty"}
            setDropDownNames={setDropDownNames}
          />
        ) : null}
        {[2, 3].includes(addParty) ? (
          <AgreementParty
            legacyAgreementFormValue={legacyAgreementFormValue}
            dropDownNames={dropDownNames}
            form={form}
            partyName={"fourthParty"}
            setDropDownNames={setDropDownNames}
          />
        ) : null}
        {[3].includes(addParty) ? (
          <AgreementParty
            legacyAgreementFormValue={legacyAgreementFormValue}
            dropDownNames={dropDownNames}
            form={form}
            partyName={"fifthParty"}
            setDropDownNames={setDropDownNames}
          />
        ) : null} */}
      </div>
      {/* <div className="flex justify-end">
        //{addParty < 3 ? (
          <Button onClick={() => setAddParty((pre) => pre + 1)}>
            Add Party
          </Button>
        ) : null}
      </div> */}
      <div className="flex flex-row justify-between">
        {uiConfigs.loading === loadingStates.LOADING ? (
          <BeatLoader color={colors.primary} size={10} />
        ) : (
          <>
            <Button
              className="max-w-xs mt-20"
              onClick={savePrev}
              // style={{
              //   backgroundColor: "#46BDE1",
              // }}
              variant="outline"
            >
              previous
            </Button>
            <Button
              className="max-w-xs mt-20"
              onClick={saveNext}
              // style={{
              //   backgroundColor: "#46BDE1",
              // }}
              variant="contained"
            >
              next
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default LegacyAgreementForm3;
